// extracted by mini-css-extract-plugin
export var actionButton = "_7n-1";
export var actionButtons = "_7n-2";
export var actions = "_7n-0";
export var aiUnread = "_7n-10";
export var alignCenter = "_7n-h";
export var backWrapper = "_7n-3";
export var cellContainer = "_7n-4";
export var checkboxContainer = "_7n-5";
export var contentContainer = "_7n-6";
export var contentHeader = "_7n-8";
export var conversationsTableWrapper = "_7n-s";
export var draftReplyBadgeContainer = "_7n-m";
export var dropdownItem = "_7n-b";
export var dropdownItemsContainer = "_7n-a";
export var dropdownTitle = "_7n-c";
export var errorIcon = "_7n-7";
export var filter = "_7n-d";
export var gray = "_7n-i";
export var headerActionButtons = "_7n-e";
export var headerCheckboxContainer = "_7n-f";
export var icon = "_7n-j";
export var menuContainer = "_7n-k";
export var noMoreTicketsIcon = "_7n-12";
export var noMoreTicketsSubText = "_7n-13";
export var oneLine = "_7n-l";
export var optionsButton = "_7n-n";
export var plus = "_7n-o";
export var portalButtonsWrapper = "_7n-g";
export var red = "_7n-p";
export var scrolledTop = "_7n-9";
export var search = "_7n-q";
export var selectedConversationsCount = "_7n-r";
export var spinner = "_7n-t";
export var strong = "_7n-u";
export var summaryCell = "_7n-v";
export var tableContainer = "_7n-11";
export var tagContainer = "_7n-w";
export var threeDots = "_7n-x";
export var twoLines = "_7n-y";
export var unread = "_7n-z";